import {
  Button,
  Center,
  Group,
  Loader,
  Stack,
  Table,
  Title,
} from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getRptSalesPersonByMonth } from "api/report.service";
import { navigateTo } from "common/navigation";
import React, { useEffect, useState } from "react";
import { RptSalesPersonByMonths } from "types/model.types";

const monthKeys = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
] as const;

const AdminSalesPersonByMonthReportPage: React.FC = () => {
  const [data, setData] = useState<RptSalesPersonByMonths>([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const apiFetchRef = React.useRef<boolean>(false);

  useEffect(() => {
    if (apiFetchRef.current === true) return;
    apiFetchRef.current = true;

    const fetchData = async () => {
      const response = await safeApiCall(getRptSalesPersonByMonth());
      apiFetchRef.current = false;
      setLoading(false);
      if (response) setData(response.data);
    };

    fetchData();
  }, []);

  return (
    <Stack>
      <Group justify="space-between" align="end" gap="sm">
        <Title order={2}>Sales Person Monthly Report</Title>
        <Button
          onClick={() => {
            navigateTo(`/print/sales-person-by-month`);
          }}
          variant="gradient"
        >
          Print
        </Button>
      </Group>

      {loading ? (
        <Center>
          <Loader />
        </Center>
      ) : (
        <div id="preview-content">
          <Table striped highlightOnHover withTableBorder withColumnBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Sales Person</Table.Th>
                <Table.Th>Debtor</Table.Th>
                {monthKeys.map((month) => (
                  <Table.Th className="money" key={month}>
                    {month.toUpperCase()}
                  </Table.Th>
                ))}
                <Table.Th className="money">Total</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data.map((row) => (
                <Table.Tr key={`${row.salesPerson}-${row.debtorId}`}>
                  <Table.Td>{row.salesPerson}</Table.Td>
                  <Table.Td>{`[${row.debtorId}] ${row.debtor}`}</Table.Td>
                  {monthKeys.map((month) => (
                    <Table.Td className="money" key={month}>
                      {row[month]}
                    </Table.Td>
                  ))}
                  <Table.Td className="money">
                    <strong>{row.totalSales}</strong>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
      )}
    </Stack>
  );
};

export default AdminSalesPersonByMonthReportPage;
